const initStyliticsTrack = (referenced_product, customer_id) => {
    const styliticsContainer = document.querySelector('.Stylitics-mcgee');
    if (!styliticsContainer) return;
    styliticsContainer.addEventListener('click', (event) => {
        const gridItem = event.target.closest('[data-testid="stylitics-grid-item"]');
        if (!gridItem) return;
        const imgEl = gridItem.querySelector('.stylitics-ui-image')
        const product_name = imgEl?.getAttribute('alt') || null;
        const event_data = {
            product_name,
            referenced_product,
            location: 'How to Style It',
            url: window.location.href
        };
        emitAnalyticsEvent('stylitics_product_clicked', event_data, customer_id);
    }, true);
};

const initLookfyTrack = (referenced_product, customer_id) => {
    const lookfyContainer = document.querySelector('.lookfy-gallery');
    if (!lookfyContainer) return;
    document.addEventListener('click', (event) => {
        let hotspotLink = event.target.closest(".kt-tooltip");
        if (!hotspotLink) return;
        let product_name = hotspotLink?.querySelector('.hotspot-item-image a').getAttribute('aria-label')?.trim() || null;
        const event_data = {
            product_name,
            referenced_product,
            location: 'Shop the Look',
            url: window.location.href
        };
        emitAnalyticsEvent('lookfy_product_clicked', event_data, customer_id);
    }, true);
};

const sessionId = () => {
    let anonymousId = localStorage.getItem('anonymousId');
    if (!anonymousId) {
        anonymousId = crypto.randomUUID();
        localStorage.setItem('anonymousId', anonymousId);
    }
    return anonymousId;
}

const emitAnalyticsEvent = async (eventName, eventData, customer_id) => {
    try {
        const requestBody = {
            eventName,
            eventData
        };
        if (customer_id) {
            requestBody.customerId = customer_id;
        } else {
            const anonymousId = sessionId();
            requestBody.anonymousId = anonymousId;
        }
        let analytics = false;
        try {
            if (typeof Shopify !== 'undefined' && Shopify.customerPrivacy) {
                analytics = Shopify.customerPrivacy.analyticsProcessingAllowed();
            }
        } catch (error) {
            console.log('Error checking analytics permission:', error);
            analytics = false;
        }
        if (analytics) {
            const response = await fetch(`https://order-api.studiomcgee.com/custom-events`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data;
        } else {
            return null;
        }
        
    } catch (error) {
        console.error(`❌ Error publishing ${eventName}:`, error);
        return null;
    }
};
